import React, { useMemo } from 'react';
import { NetworkBaseProps } from './types';
import { NetworkUpdateLoader } from '../network-update-loader/network-update-loader';
import { Description, IconLargeWrapper, IconSmallWrapper, Wrapper } from './network-base.styles';
import { Typography } from '@shared/ui/typography/typography';

export const NetworkBase: React.FC<NetworkBaseProps> = ({
    size,
    title,
    description,
    Icon,
    customState,
    updateLoader,
    className,
}) => {
    const IconWrapper = useMemo(() => {
        switch (size) {
            case 'l': {
                return IconLargeWrapper;
            }
            case 's': {
                return IconSmallWrapper;
            }
        }
    }, [size]);

    return (
        <>
            {Boolean(customState) && customState}
            {!customState && (
                <Wrapper className={className}>
                    <IconWrapper>{Icon}</IconWrapper>
                    {title && (
                        <Typography size='h5' align='center'>
                            {title}
                        </Typography>
                    )}
                    {description && (
                        <Description size='body1_short' color='neutral_50' align='center'>
                            {description}
                        </Description>
                    )}
                </Wrapper>
            )}
            {updateLoader && <NetworkUpdateLoader {...updateLoader} />}
        </>
    );
};
